import { Icon, Text, Flex } from '@scale/scaleui-radix';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

interface ErrorMessageProps {
  text: string;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ text, className }) => {
  return (
    <Flex direction="row" align="center" gap="1" asChild className={className}>
      <Text color="error" size="2">
        <Icon size="1" icon={faCircleExclamation} label="Error" />
        {text}
      </Text>
    </Flex>
  );
};
